(function () {
  'use strict';

  // The pack/plan/gallery purchase logic lives in
  // assets/lp-bedtime-stickers-buybox.js.liquid, shared with
  // lp-bedtime-stickers-ridge — this file only handles what's specific to
  // the v1 page itself (the "Loved by families" video modal further down
  // the page, unrelated to the buy box).
  //
  // By id, not the .lp-bedtime-stickers-v1 CLASS: the announcement-bar
  // relocation script (inline, in lp-bedtime-stickers-v1.liquid) moves that
  // bar into its own wrapper carrying this same class so its styles still
  // resolve, and prepends it to the body — making it the FIRST element with
  // this class in the document. A class-based querySelector here would grab
  // that near-empty wrapper instead of the real page root.
  var root = document.getElementById('lpBedtimeStickersV1');
  if (!root) return;

  // ---------- "Loved by families" video modal ----------
  var reelCards = root.querySelectorAll('.reel-card[data-video]');
  var videoModal = root.querySelector('.video-modal');
  var videoPlayer = videoModal ? videoModal.querySelector('.video-modal__video') : null;
  var videoCloseTriggers = videoModal ? videoModal.querySelectorAll('[data-video-close]') : [];

  function openVideo(src) {
    if (!videoModal || !videoPlayer) return;
    videoPlayer.src = src;
    videoModal.classList.add('is-open');
    videoModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    videoPlayer.currentTime = 0;
    var playPromise = videoPlayer.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
  }

  function closeVideo() {
    if (!videoModal || !videoPlayer) return;
    videoPlayer.pause();
    videoModal.classList.remove('is-open');
    videoModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    videoPlayer.removeAttribute('src');
    videoPlayer.load();
  }

  reelCards.forEach(function (card) {
    card.addEventListener('click', function () {
      openVideo(card.getAttribute('data-video'));
    });
  });

  videoCloseTriggers.forEach(function (el) {
    el.addEventListener('click', closeVideo);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && videoModal && videoModal.classList.contains('is-open')) closeVideo();
  });
})();
